import React, { useCallback, useContext } from 'react';
import { DropDownOption } from 'components/inputs/DropDownOption';
import { PropertyEditorContext } from 'components/property-editors/contexts/PropertyEditorContext';
import {
  getSuggestions,
  setFromPath,
} from '@decisions/server/DecisionsFramework/Design/Flow/Service/Edit/Mapping/SequentialService';
import { SearchBox } from 'components/inputs/SearchBox';
import { IPropertyChild } from 'components/property-editors/utils/ProviderNodeUtils';

export interface ISearchProps {
  displayText: string;
  path: string[];
  child: IPropertyChild;
}

const WATERMARK = 'Type variable name';

export function Search({ displayText, path, child, ...htmlOptions }: ISearchProps) {
  const context = useContext(PropertyEditorContext);

  const onComboValueChosen = useCallback(
    (id: string | null, value: string) => {
      setFromPath({
        mappingContext: context.mappingContext,
        editingContextId: context.editingContextId,
        propertyGridPath: path,
        path: value,
      });
    },
    [context.editingContextId, context.mappingContext, path]
  );

  const onItemChosen = (value: string) => {
    onComboValueChosen(null, value);
  };

  const onSearch = useCallback(
    async (value: string) => {
      return await getSuggestions({
        mappingContext: context.mappingContext,
        path: value || '',
      });
    },
    [context.mappingContext]
  );

  return (
    <div className="dpc-ddpath-editor__search" {...htmlOptions}>
      <SearchBox
        search={onSearch}
        className={'dpc-ddpath-editor__input'}
        placeholder={WATERMARK}
        showClearIcon={false}
        showSearchIcon={false}
        onItemChosen={onItemChosen}
        doNotEmitOnBlur={true}
        inputProps={{
          searchText: displayText,
        }}
        itemTemplate={({ item, index, isFocused }) => (
          <DropDownOption
            key={`${item}`}
            index={index}
            onChosen={onComboValueChosen}
            isChosen={false}
            isFocused={isFocused}
          >
            {item}
          </DropDownOption>
        )}
      />
    </div>
  );
}
